<div class="row mt-4">
  <div class="col-md-12">
      <h3>
          <span translate={{title}}></span> <span *ngIf="count && count!=='0'"> ({{count}})</span>
      </h3>
  </div>
</div>